export default __webpack_public_path__ + "static/media/button-left-no-border.0c3ec62a.svg";